export default [
  {
    desk_label: 'desk',
    room_label: 'room',
    parking_label: 'parking',
    analytics_label: 'Analytics',
    reception_label: 'Reception',
    desk_title: 'Choose a desk',
    room_title: 'Choose a room',
    date_label: 'Date',
    dateStartWeek_label: 'Select week start date',
    dateStartMonth_label: 'Select month start date',
    dateEndWeek_label: 'Weekend date',
    dateEndMonth_label: 'Month end date',
    time_label: 'Time',
    dateStart_label: 'Date start',
    dateStartViewMode_label: 'Date',
    dateEnd_label: 'Date end',
    office_label: 'Select an office',
    floor_label: 'Select a floor',
    area_label: 'Select an area',
    availability_label: 'Only available',
    capacity_label: 'Capacity',
    equipment_label: 'Equipment',
    deskNoItems_message: 'No desk found.',
    roomNoItems_message: 'No room found.',
    deskNoAvailableItems_message: 'No available desks.',
    roomNoAvailableItems_message: 'No available rooms.',
    ethernet_label: 'Ethernet',
    videoconference_label: 'Videoconference',
    microphone_label: 'Microphone',
    camera_label: 'Camera',
    speaker_label: 'Speaker',
    monitor_label: 'Monitor',
    standardWorkspace_label: 'Standard workspace',
    graphicsWorkspace_label: 'Graphics workspace',
    lamp_label: 'Desklamp',
    designatedWorkspace_label: 'Designated workspace',
    refresh_label: 'Refresh',
    confirm_label: 'Confirm',
    cancel_label: 'Cancel',
    book_label: 'Book ',
    show_label: 'View',
    unbook_label: 'Unbook ',
    viewMode_label: 'The grid is in view mode, to book a room you need to open the plugin within Outlook.',
    from_label: ' from ',
    to_label: ' to ',
    booked_label: ' booked',
    unbooked_label: ' unbooked',
    generic_error: 'ops! a problem has occurred.',
    name_label: 'Name',
    company_label: 'Company',
    service_location_label: 'Service location',
    department_label: 'Department',
    filter_label: 'Search filters',
    status_label: 'Status',
    alreadyBooked_label: ' not available',
    overlap_label: 'already booked ',
    pageNotFound_error: 'Page not found',
    firstname_label: 'First Name',
    lastname_label: 'Last Name',
    email_label: 'Email',
    realtime_label: 'Real time',
    daily_label: 'Daily',
    weekly_label: 'Weekly',
    monthly_label: 'Monthly',

    timeManagement_label: 'Time Management',
    officesOccupations_label: 'Office occupations',
    roomOccupations_label: 'Room occupations',
    parkingOccupations_label: 'Parking occupations',
    timeManagementADM_label: 'Time Management Admin',

    room_list_label: 'Room list',
    room_top_users_label: 'Top users',
    average_minutes_booked_label: 'Average minutes booked in period',
    minutes_booked_by_range_label: 'Minutes booked - Average by hour range',
    minutes_booked_by_date_label: 'Minutes booked - Average by day',
    most_booked_rooms_label: 'Most booked rooms',

    meetingList_label: 'Meeting List',
    externalCustomerList_label: 'External Customer List',
    smartReceptionAccesses_label: 'Smart Reception registrations',
    accessList_label: 'Smart Gate access list',
    passHandler_label: 'Pass Handler',

    academy_label: 'Academy',
    courseList_label: 'Class list',
    courseCalendar_label: 'Class calendar',
    employeeRecap_label: 'Employee recap',
    academyFAQ_label: 'Frequently Asked Questions (FAQ)',

    tutorial_label: 'Tutorial',
    searchUser_label: 'Search user',
    referent_label: 'Referent',
    employment_statistics_locations_label: 'Average office occupancy statistics',
    booking_cancellations_label: 'Booking cancellations',
    check_in_out_label: 'Check in/out',
    export_label: 'Export',
    most_booked_desks_label: 'Top booked desks',
    less_booked_desks_label: 'Less booked desks',
    users_multiple_bookings_label: 'Top users by bookings',
    users_fewer_bookings_label: 'Users with fewer bookings',
    heatmap_bookings_label: 'Bookings heatmap',
    histogram_desks_label: 'Reservations desk',
    bookings_singular_label: 'reservation',
    bookings_plural_label: 'reservations',
    capitalized_booked_label: 'Booked',
    free_label: 'Free',
    statistics_working_status_label: 'Statistics working status',
    all_label: 'All',
    notDefined_label: 'Not defined',
    unknown_label: 'Unknown',
    statistics_office_ws_label: 'Office working status',
    statistics_ws_heatmap_label: 'Heatmap working status',
    employment_statistics_locations_user_label: 'Employment statistics locations for user',
    unknown_working_state: 'Unknown',
    select_user_placeholder: 'Select a user',
    abbreviation_department_label: 'Dept:',
    tot_5_users_month_working_status_label: 'Top users of month for working status',
    others_label: 'Others',
    total_label: 'Total',
    working_state_label: 'Working State',
    totals_label: 'Totals',
    close_label: 'Close',
    notFillFields_label: 'Please fill out all required fields',
    state_meeting_label: 'State meetings',
    organizer_name_label: 'Organizer Name / Email',
    name_participant_label: 'Participant Name / Email',
    input_placeholder: 'min. 3 char',
    show_detail: 'Show details',

    //Parking Stats labels
    parking_stats_occupancy_label: 'Parking occupancy',
    parking_stats_usage_label: 'Cancelled parking reservations',
    parking_stats_histogram_label: 'Average reservations per day',
    parking_stats_heatmap_label: 'Reservations per day',

    average_label: 'Average',

    id_customer_label: 'ID',

    portal_dismissed: 'Go to Web App',
    portal_continue: 'Continue with the current one',
  },
];
